import vipDetail from './vipDetail.js';
import vipOrder from './vipOrder.js';
import freeGoldVIP from './freeGoldVIP'
import receiveFree from './receiveFree'
import guangdaCard from './guangdaCard'
import eventTrack from '@/api/eventTrack'

import merge from '@/utils/merge';

let vip = merge({}, vipDetail, vipOrder, freeGoldVIP, receiveFree,guangdaCard);

const request = pid => params => {
  return vip[pid](params);
};

export default {
  getVipDetail: request(333007),
  createVipOrder: request(331406),
  getCashTicket: request(331407),
  freeGoldVIP: request(331577),
  queryConfigById: request(331673),
  sendGoldMember: request(331674),
  guangdaCard:request(331720),
  eventTrack: (data = {}) => {
    return eventTrack['621000'](data)
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/service/index.js